import React from 'react';
import './EVMap.scss';

interface IEVCutline {
  cutlineText: string;
}

export function EVCutline({ cutlineText }: IEVCutline): JSX.Element {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const cutlineClass = isHonda ? 'ev-map-honda' : 'ev-map';
  return (
    <div className={`${cutlineClass}__textbox`}>
      <p className={`${cutlineClass}__cutline ahm-legacy-label3`}>
        {cutlineText}
      </p>
    </div>
  );
}

export default EVCutline;
